
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scheme/[...slug]",
      function () {
        return require("private-next-pages/scheme/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scheme/[...slug]"])
      });
    }
  